import { useOnnxModel } from "./useOnnxModel"

export const DOCUMENTS_MODEL_URL =
  "https://public.instacover.ai/documentModels/model-45d0da44049c419792ac362d9a39b2f7.onnx"

export function useDocumentModelQuery(enabled: boolean) {
  return useOnnxModel({
    modelUrl: DOCUMENTS_MODEL_URL,
    enabled,
  })
}
